import {
	createStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
const styles = (theme: Theme) => {
	return createStyles({
		scrollbarWrapper_barWrapper: {
			height: '100%',
			display: 'flex',
			minHeight: 0,
			flexDirection: 'column',
			overflow: CSS.supports('overflow', 'overlay') ? 'overlay' : 'auto',
			scrollbarWidth: 'thin',
			scrollbarColor: CSS.supports('scrollbar-color', alpha(theme.palette.common.black, .2)) ? alpha(theme.palette.common.black, .2) : `${alpha(theme.palette.common.black, .2)} transparent`,
			'&::-webkit-scrollbar': {
				width: '14px',
				height: '14px',
				backgroundColor: 'transparent',
			},
			'&::-webkit-scrollbar-track': {
				backgroundColor: 'transparent',
			},
			'&::-webkit-scrollbar-thumb': {
				transition: 'background ease-in-out 300ms',
				borderRadius: '10px',
				background: alpha(theme.palette.common.black, .2),
				border: 'solid 4px transparent',
				backgroundClip: 'padding-box',
			},
			'&::-webkit-scrollbar-corner': {
				backgroundColor: 'transparent',
			}
		},
		scrollbarWrapper_barBody: {
			
		},
	});
}

export default styles;
